import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { AngleDown } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { forwardRef } from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props {
  title: string
  placeholder: string
  icon: React.FC
}

export const SelectButton = forwardRef<HTMLButtonElement, Props>(
  ({ title, placeholder, icon: Icon }, ref) => {
    const { active, open } = DropdownMenu.useTrigger()

    return (
      <button
        ref={ref}
        onClick={open}
        className={clsJoin(css.button, active && css.active)}
      >
        <span className={css.leading_icon}>
          <Icon />
        </span>
        <span className={clsJoin(css.label, !title && css.placeholder)}>
          {title || placeholder}
        </span>
        <AngleDown className={css.chevron} />
      </button>
    )
  }
)
